import { Injectable } from '@angular/core';
import { EndUserViewsPermissionsDto } from '@osos/shared/api';
import { DataViewsPermissionsForEndUserPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DataViewsPermissionsForEndUserParserV1Service } from '../../parsers/data-views-parser/data-views-permissions-for-end-user-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class DataViewsPermissionsForEndUserFactoryService extends FactoryBase<
  EndUserViewsPermissionsDto,
  DataViewsPermissionsForEndUserPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataViewsPermissionsForEndUserParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(
    presenter: DataViewsPermissionsForEndUserPresenterModel,
  ): EndUserViewsPermissionsDto {
    const parser = this.getParser(
      EndUserViewsPermissionsDto,
      DataViewsPermissionsForEndUserPresenterModel,
      1,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(
    model: EndUserViewsPermissionsDto,
  ): DataViewsPermissionsForEndUserPresenterModel {
    const parser = this.getParser(
      EndUserViewsPermissionsDto,
      DataViewsPermissionsForEndUserPresenterModel,
      1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
